import React, { createContext, useContext, useState, useMemo } from "react";

const LangContext = createContext(null);

const DICT = {
  es: {
    brand: "Canales Furniture",
    tagline: "Revista Educativa Interactiva",
    subtitle: "Aprende a vender como Carlos y Ana",
    start: "Abrir Revista",
    admin: "Panel Admin",
    login: "Entrar",
    logout: "Salir",
    chapters: "Capítulos",
    games: "Juegos",
    stories: "Historias",
    exams: "Exámenes",
    dashboard: "Dashboard",
    responses: "Respuestas",
    employees: "Empleados",
    questions: "Banco de Preguntas",
    createExam: "Crear examen",
    yourName: "Tu nombre",
    startExam: "Comenzar examen",
    submit: "Enviar",
    next: "Siguiente",
    previous: "Anterior",
    finish: "Terminar",
    correct: "¡Correcto!",
    incorrect: "Respuesta incorrecta",
    tryAgain: "Intentar de nuevo",
    passed: "APROBADO",
    failed: "REPROBADO",
    stars: "Estrellas",
    downloadCert: "Descargar certificado",
    didYouKnow: "¿SABÍAS QUÉ?",
    important: "IMPORTANTE",
    remember: "RECUERDA",
    commonError: "ERROR COMÚN",
    doIt: "QUÉ HACER",
    dontDoIt: "QUÉ NO HACER",
    story: "Historia de Carlos",
    correctAnswer: "La respuesta correcta era:",
    yourAnswer: "Tu respuesta:",
    unanswered: "Sin respuesta",
    congrats: "¡Felicitaciones!",
    exportExcel: "Excel",
    exportPdf: "PDF",
    copyLink: "Copiar link",
    linkCopied: "¡Link copiado!",
    time: "Tiempo",
    minutes: "min",
    seconds: "seg",
    unlimited: "Sin límite",
    passingScore: "Puntaje para aprobar",
    illustrations: "Ilustraciones",
    exportPdfMag: "Exportar Revista (PDF)",
    yourBadges: "Tus insignias",
    yourTier: "Tu rango",
    category: "Categoría",
    sales: "Ventas",
    service: "Servicio",
    financing: "Financiamiento",
    custom: "Personalizado",
    all: "Todas",
    delete: "Eliminar",
    edit: "Editar",
    save: "Guardar",
    cancel: "Cancelar",
    add: "Añadir",
    scanQR: "Escanea para responder",
    heroCTA: "Empieza tu aventura",
    ranking: "Ranking",
    avgScore: "Promedio de aciertos",
    totalAttempts: "Total respuestas",
    totalExams: "Exámenes creados",
    topFails: "Preguntas más falladas",
    noAttempts: "Aún no hay intentos.",
    magazineDesc: "Pasa las páginas y aprende con Carlos, Ana y la mascota.",
    gameOrderTitle: "Ordena los pasos",
    gameFabTitle: "F.A.B. Matcher",
    gameErrorTitle: "Encuentra el error",
    quickQuiz: "Quiz rápido",
    onboarding: "Ruta",
    aiGenerator: "Generador AI",
    goldenCert: "Certificado Dorado",
    canalesExpert: "Experto Canales",
    certificates: "Certificados",
    askAdminForCert: "Pídele al admin que emita tu certificado dorado",
    roles: "Roles",
    chooseYourRole: "Elige tu rol",
    requiredExams: "Exámenes obligatorios",
    bonusExams: "Exámenes bonus",
    settings: "Configuración",
    stats: "Estadísticas",
    comics: "Cómics",
    library: "Biblioteca",
  },
  en: {
    brand: "Canales Furniture",
    tagline: "Interactive Learning Magazine",
    subtitle: "Learn to sell like Carlos and Ana",
    start: "Open Magazine",
    admin: "Admin Panel",
    login: "Sign in with Google",
    logout: "Sign out",
    chapters: "Chapters",
    games: "Games",
    stories: "Stories",
    exams: "Exams",
    dashboard: "Dashboard",
    responses: "Responses",
    employees: "Employees",
    questions: "Question Bank",
    createExam: "Create exam",
    yourName: "Your name",
    startExam: "Start exam",
    submit: "Submit",
    next: "Next",
    previous: "Previous",
    finish: "Finish",
    correct: "Correct!",
    incorrect: "Wrong answer",
    tryAgain: "Try again",
    passed: "PASSED",
    failed: "FAILED",
    stars: "Stars",
    downloadCert: "Download certificate",
    didYouKnow: "DID YOU KNOW?",
    important: "IMPORTANT",
    remember: "REMEMBER",
    commonError: "COMMON MISTAKE",
    doIt: "WHAT TO DO",
    dontDoIt: "WHAT NOT TO DO",
    story: "Carlos' story",
    correctAnswer: "The correct answer was:",
    yourAnswer: "Your answer:",
    unanswered: "No answer",
    congrats: "Congratulations!",
    exportExcel: "Excel",
    exportPdf: "PDF",
    copyLink: "Copy link",
    linkCopied: "Link copied!",
    time: "Time",
    minutes: "min",
    seconds: "sec",
    unlimited: "No limit",
    passingScore: "Passing score",
    illustrations: "Illustrations",
    exportPdfMag: "Export Magazine (PDF)",
    yourBadges: "Your badges",
    yourTier: "Your tier",
    category: "Category",
    sales: "Sales",
    service: "Service",
    financing: "Financing",
    custom: "Custom",
    all: "All",
    delete: "Delete",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    add: "Add",
    scanQR: "Scan to answer",
    heroCTA: "Start your adventure",
    ranking: "Ranking",
    avgScore: "Avg score",
    totalAttempts: "Total attempts",
    totalExams: "Exams created",
    topFails: "Top failed questions",
    noAttempts: "No attempts yet.",
    magazineDesc: "Turn the pages and learn with Carlos, Ana and the mascot.",
    gameOrderTitle: "Order the steps",
    gameFabTitle: "F.A.B. Matcher",
    gameErrorTitle: "Find the mistake",
    quickQuiz: "Quick quiz",
    onboarding: "Path",
    aiGenerator: "AI Generator",
    goldenCert: "Golden Certificate",
    canalesExpert: "Canales Expert",
    certificates: "Certificates",
    askAdminForCert: "Ask the admin to issue your golden certificate",
    roles: "Roles",
    chooseYourRole: "Choose your role",
    requiredExams: "Required exams",
    bonusExams: "Bonus exams",
    settings: "Settings",
    stats: "Statistics",
    comics: "Comics",
    library: "Library",
  },
};

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "es");
  const toggle = () => {
    const next = lang === "es" ? "en" : "es";
    localStorage.setItem("lang", next);
    setLang(next);
  };
  const value = useMemo(() => ({
    lang,
    setLang,
    toggle,
    t: (k) => DICT[lang][k] || DICT.es[k] || k,
    pick: (obj, key) => obj?.[`${key}_${lang}`] ?? obj?.[`${key}_es`] ?? "",
  }), [lang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
